module.exports = __webpack_public_path__ + "static/media/double-up-arrow-icon.94f3b6c1.svg";